import React from "react";
import { IIcon } from "./Icon.types";

const PlayIcon: React.FC<IIcon> = ({
  width= "32",
  height= "32",
  fill= "#FFFFFF",
  viewBox= "0 0 32 32",
  onClick,
  className,
}: IIcon): React.JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      stroke={fill}
      viewBox={viewBox}
      onClick={onClick}
      className={className}
      data-testid="playIcon"
    >
      <path
        d="M26.5 15.134C27.1667 15.5189 27.1667 16.4811 26.5 16.866L11.5 25.5263C10.8333 25.9112 10 25.4301 10 24.6603L10 7.33975C10 6.56995 10.8333 6.08882 11.5 6.47372L26.5 15.134Z"
        fill="white"
      />
    </svg>
  );
};

export default PlayIcon;
